var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4987 8.62484V1.9165L9.58203 3.83317",
    stroke: "#002A58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1.9165L13.4167 3.83317",
    stroke: "#002A58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89844 12.4585H6.12469C6.48885 12.4585 6.81469 12.6597 6.97761 12.9856L8.09885 15.2281C8.42469 15.8797 9.08594 16.2918 9.81427 16.2918H13.1972C13.9255 16.2918 14.5868 15.8797 14.9126 15.2281L16.0339 12.9856C16.1968 12.6597 16.5322 12.4585 16.8868 12.4585H21.0651",
    stroke: "#002A58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70964 4.91602C3.31714 5.41435 1.91797 7.40768 1.91797 11.4998V14.3748C1.91797 19.1664 3.83464 21.0831 8.6263 21.0831H14.3763C19.168 21.0831 21.0846 19.1664 21.0846 14.3748V11.4998C21.0846 7.40768 19.6855 5.41435 16.293 4.91602",
    stroke: "#002A58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectSend);
export default __webpack_public_path__ + "static/media/direct-send.37ea5e27883e468dcf1d49eb016ff6aa.svg";
export { ForwardRef as ReactComponent };